import { FC } from 'react'
import { Tooltip as MuiTooltip } from '@mui/material'
import theme from 'theme'

/* Components */
import { styled } from '@mui/material/styles'
import { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'

const Tooltip = styled(({ className, ...props }: TooltipProps) => (
  <MuiTooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    padding: `${theme.spacing.md}px`,
    marginTop: `${theme.spacing.xSmall}px !important`,
    fontFamily: theme.typography.fontFamily.primary,
    fontSize: theme.typography.fontSize.medium,
    lineHeight: '140%',
    fontWeight: theme.typography.fontWeight.extraThick,
    color: theme.colors.menuItemText,
    borderRadius: theme.attributes.borderRadius.tertiary,
    boxShadow: theme.colors.tooltipShadow,
    background: theme.colors.tooltipBg
  }
})

interface Props extends TooltipProps {
  title: TooltipProps['title']
}

const OnyxiaTooltip: FC<Props> = ({ title, ...rest }) => (
  <Tooltip title={title} {...rest}>
    {rest.children}
  </Tooltip>
)

export default OnyxiaTooltip
